import $ from './vendor/jquery-3.4.1.min.js';

window.originalConsole = window.console;
window.fakeConsole = [];
Object.keys(window.console).forEach(function(key) {
  fakeConsole[key] = function() {};
});
function disableConsoleLog() {
  window.console = window.fakeConsole;
}
function enableConsoleLog() {
  window.console = originalConsole;
}
if (window.appConfig && !window.appConfig.debug) {
  disableConsoleLog();
}

function updateOnlineList() {
  console.log('updateOnlineList');
  $.get('/performers/online-list', function(data) {
    //console.log('updateOnlineList data', data);
    $('#onlineList').html(data);
  });
}

function startOnlineListUpdater() {
  setInterval(updateOnlineList, 30000);
}


function withTiming(def, category, timing_var) {
  var call_started = Date.now();
  return def.always(function () {
    console.log('[Time]', category, timing_var, Date.now() - call_started);
    window.ga && ga('send', {
      hitType: 'timing',
      timingCategory: category,
      timingVar: timing_var,
      timingValue: Date.now() - call_started
    });
  });
}


function api(endpoint, data, rtype) {
  var result = $.Deferred();
  var settings = {
    url: appConfig.apiAddress + endpoint,
    contentType: 'application/json',
    type: rtype || 'GET',
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    },
    error: function (jqXHR, exception) {
      var error;
      if (jqXHR.status === 0) {
        error = 'No connection.\n Verify Network.';
      } else if (jqXHR.status == 404) {
        error = 'Requested page not found. [404]';
      } else if (jqXHR.status == 403) {
        //alert('forbidden');
      } else if (jqXHR.status == 500) {
        error = 'Internal Server Error [500].';
      } else if (jqXHR.status == 503) {
        error = 'Internal Server Error [503].';
      } else if (exception === 'parsererror') {
        error = 'Requested JSON parse failed.';
      } else if (exception === 'timeout') {
        error = 'Time out error.';
      } else if (exception === 'abort') {
        error = 'Ajax request aborted.';
      } else {
        error = 'Uncaught Error.\n' + jqXHR.responseText;
      }
      //if (error) monitorHttpEvent(monitorEvents.app_service_unavailable);
    }
  };


  if (data && rtype !== 'GET') {
    settings['type'] = rtype || 'POST';
    settings['data'] = JSON.stringify(data);
  }
  if (data && rtype == 'GET') {
    settings['data'] = data;
  }
  if (data === null) {
    settings['type'] = rtype || 'POST'; //POST without data
  }

  var ajax = $.ajax(settings).done(function(response) {
    if (response.errors) {
      result.reject(response.errors)
    } else {
      result.resolve(response.data, response.paging || null)
    }
  }).fail(function(response) {
    var errors = {errorType: 'system', errorMessage: 'Error. Request can not be completed!', errorData: null};
    if (response.responseJSON && response.responseJSON.errors) {
      errors = response.responseJSON.errors;
    }
    result.reject(errors);

    var reason = 'unknown';
    if (errors.errorType == 'not_allowed') {
      reason = 'not_allowed';
      if (errors.errorData) {
        if (errors.errorData.force_verification) {
          reason = 'force_verification';
          //BLRep('API: sendHomeAlert FORCED VIP', data);
          window.location.href = '/vip/combined/verify/0';
        } else if (errors.errorData.is_ccsuspended) {
          reason = 'is_ccsuspended';
          //BLRep('API: sendHomeAlert is_ccsuspended', data);
          window.location.href = '/vip/combined/verify/0';
        } else if (errors.errorData.email && !errors.errorData.is_confirmed) {
          reason = 'email_not_confirmed';
          //BLRep('API: sendHomeAlert confirm_email', data);
          window.location.href = '/confirm-email/';
        } else if (errors.errorData.ppu_billing_attempts) {
          reason = 'ppu_billing_attempts';
          //BLRep('API: sendHomeAlert ppu_billing_attempts', data);
          //app.trigger('rebill_ppu');
        }
      } else {
        // that should not happen according to API doc
        //BLRep('API !!! : sendHomeAlert error', data);
      }
    }

  });
  result.progress(function (what) {
    if (what == 'abort') ajax.abort();
  });


  return result;
}

// apps/user_level.js self.on('refresh_level'
function userRefreshLevel(user, verification) {
  if (user.force_verification) {
    window.location.href = '/vip/combined/verify/0';
  } else if (verification.level_claims) {
    window.location.href = '/user-level/' + verification.level_claims;
  }
}

function BLRep(msg, data) {
  appConfig.useRollbar && window.Rollbar && window.Rollbar.info(msg, data);
  if (!window.Rollbar || window.console) {
    console.info('BLREP', msg, data);
  }
}


function getDocHeight() {
  var d = window.document;
  var heights = [0];
  ['scrollHeight', 'offsetHeight', 'clientHeight'].forEach(function(field) {
    if (d.body && d.body[field]) heights.push(d.body[field]);
    if (d.documentElement && d.documentElement[field]) heights.push(d.documentElement[field]);
  });
  return Math.max.apply(null, heights);
}
// put messenger bar over footer block, if page scrolled to bottom
$(window).on('load scroll resize', function () {
  var footerHeight = parseInt(getCssVar('--height-footer'));
  var scrollTop = $(window).scrollTop();
  var windowHeight = $(window).height();
  var docHeight = getDocHeight();
  if (docHeight - windowHeight - scrollTop <= footerHeight) {
    var footerVisiblePartHeight = Math.abs(docHeight - windowHeight - scrollTop - footerHeight);
    $('#chatbar').css('bottom', footerVisiblePartHeight+'px');
  } else {
    $('#chatbar').css('bottom', 0);
  }
});


function getApiErrorsAsHash(errors) {
  //console.log('getApiErrorsAsHash', errors);
  var emap = {};  // { fieldName: [error1, error2, error3] }
  if (Object.prototype.toString.call(errors) === '[object Array]') {
    errors.forEach(function(error){
      if (!emap[error.errorData.fieldName]) emap[error.errorData.fieldName] = [];
      emap[error.errorData.fieldName].push(error.errorData.errorMessage);
    });
  } else if ('errorData' in errors && errors.errorData != null && 'fieldName' in errors.errorData) {
    emap[errors.errorData.fieldName] = [errors.errorData.errorMessage];
  } else if ('errorMessage' in errors) {
    emap['no_field'] = [errors.errorMessage];
  }
  return emap;
}

function getApiErrorsTextFromHash(emap, delimiter) {
  delimiter = delimiter || '\n';
  var errorText = '';
  for (var ef in emap) {
    for (var i=0; i<emap[ef].length; i++) {
      errorText += emap[ef][i] + delimiter;
    }
  }
  return (errorText.length == 0) ? '' : errorText.substring(0, errorText.length - delimiter.length);
}

function performerAvatar(performer, size) {
  size = size || '160x160';
  var gender = String(performer.gender).toLowerCase();
  if (!isNaN(performer.gender)) {
    gender  = 'female';
    if (performer.gender == 1) gender = 'male';
    else if (performer.gender == 3) gender = 'tranny';
  }

  var hasPhoto = false;
  if (performer.isPhoto && (performer.isPhoto === true || performer.isPhoto === 1 || performer.isPhoto === 'true')) hasPhoto = true;
  if (performer.photo && (performer.photo === true || performer.photo === 1 || performer.photo === 'true')) hasPhoto = true;
  if (performer.has_photo && (performer.has_photo === true || performer.has_photo === 1 || performer.has_photo === 'true')) hasPhoto = true;

  return (hasPhoto)
    ? appConfig.staticServerAddress + '/photos/avatars/models/' + size + '/' + performer.id + '.jpg?ts=' + (performer.photoChangedTS||1)
    : appConfig.assetNoPhotoPath + size + '_' + gender + '.' + appConfig.assetNoPhotoExt;
}

function adminAvatar(user, size) {
  size = size || '160x160';
  var hasPhoto = false;
  if (user.isPhoto && (user.isPhoto === true || user.isPhoto === 1 || user.isPhoto === 'true')) hasPhoto = true;
  if (user.photo && (user.photo === true || user.photo === 1 || user.photo === 'true')) hasPhoto = true;
  if (user.has_photo && (user.has_photo === true || user.has_photo === 1 || user.has_photo === 'true')) hasPhoto = true;

  return (hasPhoto)
    ? appConfig.staticServerAddress + '/photos/avatars/models/' + size + '/' + user.id + '.jpg'
    : appConfig.assetNoPhotoPath + size + '_male.' + appConfig.assetNoPhotoExt;
}

function userAvatar(user, size) {
  size = size || '160x160';
  var gender = String(user.gender).toLowerCase();
  if (!isNaN(user.gender)) {
    gender  = 'female';
    if (user.gender == 1) gender = 'male';
    else if (user.gender == 3) gender = 'tranny';
  }

  var hasPhoto = false;
  if (user.isPhoto && (user.isPhoto === true || user.isPhoto === 1 || user.isPhoto === 'true')) hasPhoto = true;
  if (user.photo && (user.photo === true || user.photo === 1 || user.photo === 'true')) hasPhoto = true;

  return (hasPhoto)
    ? appConfig.staticServerAddress + '/photos/avatars/users/' + size + '/' + user.id + '.jpg'
    : appConfig.assetNoPhotoPath + size + '_' + gender + '.' + appConfig.assetNoPhotoExt;
}

function userPhoto(filename, size) {
  size = size || '160x160';
  return appConfig.staticServerAddress + '/photos/users/' + size + '/' + filename;
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function simplePromise() {
  var resolve, reject;
  var promise = new Promise(function(origResolve, origReject) {
    resolve = origResolve;
    reject = origReject;
  });
  return { promise: promise, resolve: resolve, reject: reject };
}


function browserCanUseCssVariables() {
  return window.CSS && CSS.supports('color', 'var(--fake-var)');
}

function convertRemToPixels(rem) {
  if (rem.indexOf('rem') !== -1) rem = rem.replace('rem', '');
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

function getCssVar(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name);
}

function updateCssVar(name, value) {
  document.documentElement.style.setProperty(name, value);
}

function removeCssVar(name) {
  document.documentElement.style.removeProperty(name);
}

var allowPostMessageFrom = ['https://www.buildcams.com', 'https://www.buildcams.loc'];
window.addEventListener('message', function(event) {
  //console.log('message', allowPostMessageFrom.indexOf(event.origin), event);
  if (!event || allowPostMessageFrom.indexOf(event.origin) < 0 ) {
    return; //not our message
  }
  var data = event.data;
  switch (data.action) {
    case 'update_css_var':
      updateCssVar(data.var_name, data.var_value);
      break;
  }
}, false);

// notify skin builder about we are loaded
if (window.parent && window.parent !== window && window.parent.frames) {
  window.addEventListener('DOMContentLoaded', function() {
    try {
      allowPostMessageFrom.forEach(function(targetOrigin) {
        window.parent.frames[0].postMessage('ready_for_css_vars_update', targetOrigin);
      });
    } catch (e) {}
  });
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function Q(sel, element, callback) {
  var tpl = Q.flatten_template.apply(Q, arguments);
  // console.log('flatten query', tpl);
  // console.log('sel', sel);
  // console.log('element', element);
  // console.log('callback', callback);
  if (tpl) {
    sel = tpl;
    element = document;
  } else if (typeof element === 'function' ) {
    callback = element;
    element = document;
    var e = (element || document).querySelector(sel);
    if (e) {
      return callback(e) || e;
    }
  } else if (typeof callback === 'function') {
    var e = (element || document).querySelector(sel);
    if (e) {
      return callback(e) || e;
    }
  }
  return (element || document).querySelector(sel);
}

Q.flatten_template = function (strings) {
  if (strings instanceof Array) {
    var result = [];
    strings.forEach(function(val, i) {
      result.push(val, arguments[i + 1]);
    });
    return result.join('');
  }
};

function QQ(selector, callback) {
  var base = this === window ? document : this;
  var tpl = Q.flatten_template.apply(Q, arguments);
  if (tpl) return base.querySelectorAll(tpl);
  else if (callback) {
    return base.querySelectorAll(selector).forEach(function(node) { callback(node) })
  } else {
    return base.querySelectorAll(selector);
  }
}

Element.prototype.Q = Q;
Element.prototype.QQ = QQ;




function stopCountdownTimer(timer) {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}

function secondsToMMSS(secs) {
  secs = parseInt(secs, 10);
  var hours = Math.floor(secs / 3600);
  var minutes = Math.floor((secs - (hours * 3600)) / 60);
  var seconds = secs - (hours * 3600) - (minutes * 60);

  if (hours < 10) hours = '0' + hours;
  if (minutes < 10) minutes = '0' + minutes;
  if (seconds < 10) seconds = '0' + seconds;
  // return hours + ':' + minutes + ':' + seconds;
  return minutes + ':' + seconds;
}


function renderCountdownTimer(endTime, renderTo) {

  function tick() {
    var timeLeft = (endTime * 1000 - (new Date()).getTime()) / 1000;
    if (timeLeft < 0) timeLeft = 0;
    timeLeft = parseInt(timeLeft, 10);
    if (renderTo.length) {
      for (var i=0; i<renderTo.length; i++) {
        renderTo[i].textContent = isNaN(timeLeft) ? '--:--' : secondsToMMSS(timeLeft);
      }
    } else {
      renderTo.textContent = isNaN(timeLeft) ? '--:--' : secondsToMMSS(timeLeft);
    }
  }

  tick();
  return setInterval(tick, 1000);
}



function setCookie(cname, cvalue, expmin, domain) {
  var d = new Date();
  var expires  = '';
  if (expmin!==false) {
    d.setTime(d.getTime() + (expmin ? expmin * 60 * 1000 : 0));
    expires = "expires="+d.toGMTString();
  }

  var sc = cname + "=" + cvalue + "; " + expires + (domain?';domain=.'+domain:'') + '; path=/; SameSite=Lax';
  console.log('SET COOKIE',sc);

  document.cookie = sc;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i=0; i<ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}


function getTimezoneOffset() {
  var d = new Date();
  return d.getTimezoneOffset() / 60;
}

function getTimezoneName() {
  var name = '';
  try {
    name = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    name = 'UTC';
  }
  return name;
}

function getAppPanelElementStyle(element) {
  if (!element || !element.attrs) return '';

  var allowAttrs = ['font-size', 'font-style', 'font-weight', 'color', 'left', 'right', 'top', 'width'];
  var style = '';

  for (var prop in element.attrs) {
    if (allowAttrs.indexOf(prop) !== -1) {
      var val = element.attrs[prop];
      if (isNumber(val)) val += 'px';
      style += prop + ':' + val + ';';
    }
  }

  return style;
}

function registerUser(formData) {
  window.ga && ga('send', 'event', 'Registration', 'submit');
  if (formData['birthdateYear'] && formData['birthdateMonth'] && formData['birthdateDay']) {
    formData['birthdate'] = formData['birthdateYear']+'-'+formData['birthdateMonth']+'-'+formData['birthdateDay'];
  }
  delete formData['birthdateYear'];
  delete formData['birthdateMonth'];
  delete formData['birthdateDay'];

  if (formData['gender']) {
    formData['gender'] = parseInt(formData['gender']);
  }
  if (!formData['agree']) {
    return $.Deferred().rejectWith(this, [[{
      errorData: {
        fieldName: 'agree',
        errorMessage: 'You have to agree to the Terms and Privacy Policy.'
      }
    }]]);
  }
  formData['site_id'] = appConfig.siteId;
  delete formData['agree'];

  //add traffic source cookie
  if (!Arg('ts') && !getCookie('ts')) {
    if (appConfig.mobile) {
      formData.ts = 'type_in_mobile';
    } else {
      formData.ts = formData.short_form ? 'type_in_web_shim' : 'type_in_web_form';
    }
  }

  return api('registration/', formData).done(function(data) {
    window.ga && ga('send', 'event', 'Registration', 'complete','stage1');
  }).fail(function () {
    window.ga && ga('send', 'event', 'Registration', 'rejected', 'api');
  });
}


function storageAvailable(type) {
  var storage;
  try {
    storage = window[type];
    var x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  }
  catch(e) {
    return e instanceof DOMException && (
        // everything except Firefox
      e.code === 22 ||
      // Firefox
      e.code === 1014 ||
      // test name field too, because code might not be present
      // everything except Firefox
      e.name === 'QuotaExceededError' ||
      // Firefox
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      (storage && storage.length !== 0);
  }
}
var lsAvailable = storageAvailable('localStorage');

function localStorageSet(key, value) {
  if (!lsAvailable) return false;
  localStorage.setItem(key, JSON.stringify(value));
  return true;
}

function localStorageGet(key) {
  if (!lsAvailable) return undefined;
  var raw = localStorage.getItem(key);
  if (raw === null) return null;
  return JSON.parse(raw);
}


function delegateLikeJquery(eventName, elementSelector, handler) {
  document.addEventListener(eventName, function(e) {
    // loop parent nodes from the target to the delegation node
    for (var target = e.target; target && target != this; target = target.parentNode) {
      if (target.matches(elementSelector)) {
        handler.call(target, e);
        break;
      }
    }
  }, false);
}


function sentryCaptureMessage(message, params) {
  if (!window.Sentry || !window.Sentry.captureMessage) return;

  if (params) {
    Sentry.withScope(function(scope) {
      for (var prop in params) {
        if (params.hasOwnProperty(prop)) {
          scope.setExtra(prop, params[prop]);
        }
      }
      Sentry.captureMessage(message);
    });
  } else {
    Sentry.captureMessage(message);
  }
}

function sentryCaptureException(exception, params) {
  if (!window.Sentry || !window.Sentry.captureException) return;

  if (params) {
    Sentry.withScope(function(scope) {
      for (var prop in params) {
        if (params.hasOwnProperty(prop)) {
          scope.setExtra(prop, params[prop]);
        }
      }
      Sentry.captureException(message);
    });
  } else {
    Sentry.captureException(exception);
  }
}


// https://stackoverflow.com/questions/32847752/javascript-dynamic-script-loading-via-functions-how-to-do-onload-or-readystat
function loadJs(url, handler) {
  var head = document.getElementsByTagName('head')[0] || document.documentElement;
  var js = document.createElement('script');
  js.async = true;
  js.src = url;
  var jsDone = false;
  js.onload = js.onreadystatechange = function() {
    if (!jsDone && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
      jsDone = true;

      handler();

      // Handle memory leak in IE
      js.onload = js.onreadystatechange = null;
      if ( head && js.parentNode ) {
        head.removeChild(js);
      }
    }
  };
  document.getElementsByTagName('head')[0].appendChild(js);
}



/*
window.addEventListener('beforeunload', function() {
  var pus = document.querySelector('.page-unload-spinner');
  if (pus) pus.style.display = 'block';
});
*/

